import { FormattedMessage, useIntl } from "react-intl";
import { Control } from "react-hook-form";

import { Span } from "@aglocal/web/components/Typography";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import StringField from "./StringField";

export interface CompanyFieldProps {
  currentValue?: string | null;
  control: Control<PostMeetingFormWithSummary>;
}

export default function CompanyField({
  currentValue,
  control,
}: CompanyFieldProps) {
  const { $t } = useIntl();
  return (
    <StringField
      name="currentCompany"
      label={$t(FIELD_LABELS.currentCompany)}
      control={control}
      hint={
        currentValue && (
          <FormattedMessage
            defaultMessage="Current Company: <b>{company}</b>"
            description="Hint under the current company field showing the company currently on the talent's Connected profile; {company} is that company."
            values={{
              company: currentValue,
              b: (chunks) => (
                <Span size={200} weight="bold">
                  {chunks}
                </Span>
              ),
            }}
          />
        )
      }
    />
  );
}
